import './App.scss';
import NotifyToast from './components/shared/notify-toast/NotifyToast';
import NotifyContext from './contexts/NotifyContext';
import React, { useRef } from 'react';
import DynamicNotifications from './components/profile/dynamicNotifications/DynamicNotifications';
import CheckVersionComponent from './components/base/CheckVersionComponent/CheckVersionComponent';
import { useLocation } from 'react-router-dom';
import Routing from './routes/Routing';
import 'react-toastify/dist/ReactToastify.css';
import AddHomeModal from './components/shared/add-home-modal/AddHomeModal';

function App() {

  const dynamicNotificationsRef = useRef<DynamicNotifications>(null);
  const location = useLocation()
  React.useEffect(() => {
    if (dynamicNotificationsRef.current?.state.notifications.length === 0) {
      dynamicNotificationsRef.current?.getData();
    }
  }, [location])

  return (
    <NotifyContext.Provider
      value={{
        showNotify: () => { }
      }}
    >
      <DynamicNotifications ref={dynamicNotificationsRef} />
      <CheckVersionComponent />
      <Routing />
      <NotifyToast />
      <AddHomeModal />
      
    </NotifyContext.Provider>
  );
}

export default App;
